<template>
  <div class="container mx-auto">
    <div class="w-full max-w-lg mx-auto" v-if="form_status == 0">
      <form
        class="bg-white sm:shadow-md sm:rounded px-4 sm:px-8 pt-6 pb-2 sm:pb-8 mb-2 sm:mb-4"
        @submit="on_form_submit"
        ref="entrance_form"
      >
        <div
          class="block text-gray-600 text-sm sm:py-5"
          v-if="app_type == 'desktop'"
        >
          Please select one of the options below to start.
        </div>
        <div
          class="flex items-center justify-around flex-col sm:flex-col flex-grow"
          v-if="app_type == 'desktop'"
        >
          <!--          <button-->
          <!--            class="uppercase bg-blue-800 hover:bg-blue-900 text-white font-bold py-3 sm:py-2 px-1 rounded focus:outline-none focus:shadow-outline w-full my-2"-->
          <!--            type="button"-->
          <!--            @click="do_submit($event, 'AUTO')"-->
          <!--          >-->
          <!--            GUIDED TOUR-->
          <!--          </button>-->
          <button
            class="uppercase bg-blue-800 hover:bg-blue-900 text-white font-bold py-3 sm:py-2 px-1 rounded focus:outline-none focus:shadow-outline w-full my-2"
            type="button"
            @click="do_submit($event, 'FREE')"
          >
            SELF-GUIDED
          </button>
        </div>

        <div
          class="flex items-center justify-around flex-col sm:flex-row flex-grow"
          v-if="app_type == 'mobile'"
        >
          <button
            class="bg-blue-800 hover:bg-blue-900 text-white font-bold py-3 sm:py-2 rounded focus:outline-none focus:shadow-outline w-full my-1"
            type="button"
            @click="do_submit($event, 'SIMPLE')"
          >
            CONTINUE
          </button>
        </div>
      </form>
      <p class="text-center text-gray-500 text-xs">
        Powered by ProtoExpo
      </p>
    </div>
    <div
      class="w-full max-w-lg mx-auto loading-app"
      v-if="show_loading && app_type == 'desktop'"
    >
      <img src="../assets/loading.svg" />
      <span :class="load_percentage_class">{{ load_percentage }}%</span
      >&nbsp;&nbsp; LOADING, PLEASE WAIT
    </div>

    <div
      class="w-full max-w-lg mx-auto loading-app"
      v-if="show_loading && app_type == 'mobile'"
    >
      <img src="../assets/loading.svg" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "BoothForm",
  data() {
    return {};
  },
  computed: {
    ...mapState(["form_status", "app_type", "app_state"]),
    ...mapGetters(["eventTag"]),
    show_loading() {
      return (
        this.$store.state.form_status >= 1 && this.$store.state.app_state < 0
      );
    },
    load_percentage() {
      return Math.round(this.$store.state.unity_progress * 100);
    },
    load_percentage_class() {
      var str =
        "px-4 py-1 text-white font-bold text-sm w-18 rounded-full inline-block transition duration-500 ease-in-out ";
      if (this.load_percentage < 50) {
        str += " bg-gray-400";
      } else if (this.load_percentage < 60) {
        str += " bg-gray-500";
      } else if (this.load_percentage < 70) {
        str += " bg-gray-600";
      } else if (this.load_percentage < 80) {
        str += " bg-gray-800";
      } else if (this.load_percentage < 85) {
        str += " bg-red-300";
      } else if (this.load_percentage < 95) {
        str += " bg-red-400";
      } else {
        str += "bg-red-500";
      }
      return str;
    }
  },
  methods: {
    on_form_submit(ev) {
      ev.preventDefault();
    },
    do_submit(ev, app_mode) {
      var data_to_submit = { app_mode: app_mode, skip_form: true };

      this.$store.dispatch("submit_form", data_to_submit);
      this.$refs.entrance_form.reset();

      this.$ga.event(this.eventTag + "intro_form", "app_mode", app_mode, 1);
    }
  },
  mounted() {
    this.$ga.page("/start-form");

    if (this.app_type == "mobile") {
      var data_to_submit = { app_mode: "SIMPLE", skip_form: true };

      this.$store.dispatch("submit_form", data_to_submit);
      this.$refs.entrance_form.reset();

      this.$ga.event("intro_form", "app_mode", app_mode, 1);
    }
  }
};
</script>

<style scoped>
.bg-teal {
  background-color: #00b2aa;
}
.loading-app {
  text-align: center;
  color: #999;
}
.loading-app img {
  display: block;
  width: 150px;
  height: 150px;
  min-width: 150px;
  min-height: 150px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/BoothEntry.vue